import * as React from 'react';
import { Switch } from 'react-router-dom';

// react-router doesn't have support for React fragments in <Switch />. This component
// wraps react-router's <Switch /> so that it gets fragment support.
//
// https://github.com/ReactTraining/react-router/issues/5785
export default function FragmentSupportingSwitch({ children }: any) {
	const flattenedChildren: any[] = [];
	flatten(flattenedChildren, children);
	// eslint-disable-next-line
	return React.createElement.apply(React, [Switch, null].concat(flattenedChildren));
}

function flatten(target: any, children: any) {
	React.Children.forEach(children, (child: any) => {
		if (React.isValidElement(child)) {
			if (child.type === React.Fragment) {
				flatten(target, (child.props as any).children);
			} else {
				target.push(child);
			}
		}
	});
}
